import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../context/UserContext';
import styles from './HomeLoged.module.css';

function HomeLoged() {
  const { user } = useContext(Context);

  // Captura o primeiro nome para a mensagem de boas-vindas
  const firstName = user?.name ? user.name.split(' ')[0] : 'Criador';

  return (
    <section className={styles.home_container}>
      {/* Seção Principal: Vídeo Tutorial + Resumo */}
      <div className={styles.main_content}>
        
        {/* Seção do Vídeo Tutorial */}
        <section className={styles.video_section}>
          <h2>📺 Como usar o ReproBird</h2>
          <p>Assista ao tutorial rápido abaixo e aprenda a cadastrar suas aves, gerenciar gaiolas e acompanhar suas reproduções.</p>
          
          <div className={styles.video_wrapper}>
            {/* Substitua o SRC pela URL de incorporação (embed) do seu vídeo do YouTube ou Vimeo */}
            <iframe
              src="https://www.youtube.com/embed/SEU_VIDEO_HERE"
              title="Tutorial ReproBird"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </section>

        {/* Atalhos e Destaques do Sistema */}
        <section className={styles.features_section}>
          <h2>🚀 Primeiros Passos</h2>
          <div className={styles.cards_grid}>
            
            <div className={styles.card}>
              <h3>🏠 Seu Criadouro</h3>
              <p>Configure e organize os dados do seu criadouro para controle do plantel.</p>
              <Link to="/aviary" className={styles.card_btn}>Acessar Criadouro</Link>
            </div>

            <div className={styles.card}>
              <h3>🦜 Aves</h3>
              <p>Cadastre suas aves, anilhas, mutações, nascimento e genealogia.</p>
              <Link to="/bird" className={styles.card_btn}>Gerenciar Aves</Link>
            </div>

            <div className={styles.card}>
              <h3>🏛️ Gaiolas & Reprodução</h3>
              <p>Organize suas gaiolas, forme casais e acompanhe as posturas ativas.</p>
              <Link to="/cage" className={styles.card_btn}>Ver Gaiolas</Link>
            </div>

            <div className={styles.card}>
              <div className={styles.card_icon}></div>
              <h3>📊 Relatórios</h3>
              <p>Relatórios de desenpenho, genealogia e mais.</p>
              <Link to="/report" className={styles.card_btn}>Ver Financeiro</Link>
            </div>

            <div className={styles.card}>
              <h3>💵 Financeiros</h3>
              <p>Monitore compras, vendas, custos operacionais.</p>
              <Link to="/transaction" className={styles.card_btn}>Ver Financeiro</Link>
            </div>



          </div>
        </section>

      </div>
    </section>
  );
}

export default HomeLoged;